import React from 'react';
import PropTypes from 'prop-types';
import {PlusGlyph} from '../glyphicons/Glyphicons';
import textTranslates from './translate.json';

const FileInput = (props) => {
    
    function onFileChange(e) {
        e.preventDefault();
        props.onAddFileButtonClick(e.target.files[0],props.filesTargetName);
        e.target.value=null;
    }

    return(
        <div>
            <label
                className="file-upload"
                htmlFor={props.id}>
                <PlusGlyph
                    className="file-upload-add-glyph" />
                    {textTranslates.addFileButtonText}
            </label>
            <input
                id={props.id}
                onChange={onFileChange}
                type="file" />
        </div>
    );
};

FileInput.propTypes = {
    onAddFileButtonClick: PropTypes.func
};

export default FileInput;


// WEBPACK FOOTER //
// ./src/components/File/FileInput.js